// Module
var code = `<colorPicker name="cpControl" top="10" left="10"/>`;
// Exports
export default code;